import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CatalogLauncherWizardComponent, CatalogService } from '@serengeti/serengeti-app';

@Component({
  selector: 'app-market-product-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class MarketProductCreateComponent implements OnInit {

  product: any;
  catalog: any;
	selectedTenant: any;

	@ViewChild('wizard', {static: false}) wizard: CatalogLauncherWizardComponent;

  constructor(
    private translateService: TranslateService,
		private catalogService: CatalogService
  ) { }

  ngOnInit() {
  }

  onConfigCatalog($event: any) {
    this.product = $event;
    if (this.product.catalog) {
      this.catalog = JSON.parse(JSON.stringify(this.product.catalog.catalog));
      this.catalog.activeVersion = this.product.catalog;
    } else {
      this.catalog = null;
    }
  }

  onCatalogConfigured($event: any) {
    this.product.catalogConfiguration = JSON.stringify($event);
  }

	onTenantSelected(selectedTenant: any) {
		this.selectedTenant = selectedTenant;
	}

	getSoftwareTemplateApps(softwareTemplates: any[], resourceTemplate: any): any[] {
		return this.catalogService.getSoftwareTemplateApps(softwareTemplates, resourceTemplate);
	}

	getSoftwareTemplate(softwareTemplates: any[], resourceTemplate: any) {
		return this.catalogService.getSoftwareTemplate(softwareTemplates, resourceTemplate);
	}

	onSoftwareConfigure($event: any) {
		this.wizard.onSoftwareConfigure($event);
	}
}
